import { DirectiveFunction } from 'vue';
import DOMPurify from 'isomorphic-dompurify';

export const purify: DirectiveFunction = (el, { value }) => {
  el.innerHTML = DOMPurify.sanitize(value);
};
